var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavorite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.44 9.035-4.8 4.708a.2.2 0 0 1-.28 0L3.557 9.035a3.54 3.54 0 0 1-.816-3.807A3.5 3.5 0 0 1 5.48 3.031c1.138-.153 2.2.306 3.02 1.295.818-.99 1.881-1.45 3.015-1.298a3.529 3.529 0 0 1 1.925 6.007"
})));
export default SvgFavorite;